var map = {
	"./5_how-do-we-stop-cavity-monsters.mp3": "OUYv",
	"./5_uh-oh-cavity-monsters-coming.mp3": "TrNB",
	"./5_yeah-your-fighting-the-cavity-monster.mp3": "4uFw",
	"./7_good-for-me-or-good-for-cavity-monsters.mp3": "/SR3",
	"./8_cavity-math_lets-see-how.mp3": "qB0v",
	"./8_cavity-math_oh-no.mp3": "Utw9",
	"./8_cavity-math_remember.mp3": "kE+J",
	"./8_cavity-math_thats-right.mp3": "yYvX",
	"./9_good-job.mp3": "nbN3",
	"./9_unlocked-new-badge.mp3": "G4J5",
	"./cavity-math_lets-see-how-es.mp3": "L3dO",
	"./cavity-math_lets-see-how.mp3": "wbMb",
	"./cavity-math_oh-no-es.mp3": "trrC",
	"./cavity-math_oh-no.mp3": "YiEn",
	"./cavity-math_remember-es.mp3": "ZX7m",
	"./cavity-math_remember.mp3": "1+25",
	"./cavity-math_thats-right-es.mp3": "hKgK",
	"./cavity-math_thats-right.mp3": "SBy2",
	"./do_you_want_to_play_again.mp3": "btUg",
	"./drag_the_items_to_add_up_to_healthy_teeth.mp3": "/p5N",
	"./good-for-me-or-good-for-cavity-monsters-es.mp3": "p4xF",
	"./good-for-me-or-good-for-cavity-monsters.mp3": "NKZU",
	"./good-job-es.mp3": "tdBG",
	"./good-job.mp3": "3Cs/",
	"./good_job_you_are_a_cavity_monster_hero.mp3": "Ztez",
	"./good_job_you_are_fighting_the_cavity_monsters.mp3": "73oa",
	"./putting_sugary_snacks_and_drinks_into_your_mouth.mp3": "02ft",
	"./stop-the-cavity-monster_how-do-we-es.mp3": "3h2/",
	"./stop-the-cavity-monster_how-do-we.mp3": "tl5U",
	"./stop-the-cavity-monster_yeah.mp3": "FNp3",
	"./stop-the-cavity-uh-oh-es.mp3": "dzwj",
	"./stop-the-cavity-uh-oh.mp3": "UF9v",
	"./stop-the-cavity_yeah-es.mp3": "Msec",
	"./unlocked-new-badge-es.mp3": "203u",
	"./unlocked-new-badge.mp3": "3hyA"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sX5c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio ^\.\/.*$
// module id = sX5c
// module chunks = 0